<template>
  <div class="unit-selector" :class="{ open }">
    <dropdown-select
      v-model="value"
      :options="values"
      :label-parser="labelParser"
      :multiple="false"
      @open="open = true"
      @close="open = false"
    />
  </div>
</template>

<script>
import TimeScaleSelector from './TimeScaleSelector.vue'
import DropdownSelect from './DropdownSelect.vue'

export default {
  ...TimeScaleSelector,
  components: {
    DropdownSelect,
  },
  methods: {
    labelParser(selection) {
      const label = this.values.find(d => d.id === selection[0]).label
      return `<label>Unit:</label><span class="value">${label}</span>`
    },
  },
}
</script>

<style lang="stylus">
.unit-selector
  &[data-align="top"] .dropdown-select
    transform: rotate(180deg)

    .dropdown-select__label
      transform: scale(-1, -1)
      margin-left: vw(20px)
      padding-right: vw(25px)
      margin-right: 0px

      &:after
        right: vw(-5px)

    .dropdown-option > div
      transform: scale(-1, -1)
      width: 100%

  &[data-align="bottom"] .dropdown-select
    .dropdown-select__label
      margin-right: vw(20px)
      margin-left: 0px

  .dropdown-select__label
    m-font-size(12, 16)

    > label
      margin-right: 0.5em

    .mobile &
      font-size: 0.7em
      line-height: 1.33

      .mobile &
        +m-breakpoint(landscape)
          right: 0

  .dropdown-select__options
    border-bottom-left-radius: 20px
    border-bottom-right-radius: 20px
</style>
